var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask2285\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient2286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.8 531.59 a328.62 328.62 0 1 0 657.24 0 a328.62 328.62 0 1 0 -657.24 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149.07 357.91 a215.59 215.59 0 1 0 431.18 0 a215.59 215.59 0 1 0 -431.18 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.5790361930053 852.5037620213566L1300.5621392681608 616.9155858596669 1064.9739631064713 752.9324827845114 1200.9908600313156 988.520658946201z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.14 832.66 a195.95 195.95 0 1 0 391.9 0 a195.95 195.95 0 1 0 -391.9 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.741,183.493C1399.183,183.911,1424.162,159.46,1441.628,132.117C1460.994,101.798,1479.886,65.091,1462.485,33.604C1444.748,1.509,1403.406,-4.007,1366.741,-3.389C1331.438,-2.794,1293.106,5.618,1276.426,36.738C1260.334,66.76,1277.269,101.22,1295.122,130.23C1311.834,157.386,1334.857,183.082,1366.741,183.493",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.33 313.76 a325.96 325.96 0 1 0 651.92 0 a325.96 325.96 0 1 0 -651.92 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.52 218.69 a311.73 311.73 0 1 0 623.46 0 a311.73 311.73 0 1 0 -623.46 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.646,1057.959C1734.269,1059.035,1805.182,1042.093,1841.286,984.904C1879.537,924.314,1878.803,844.18,1839.375,784.349C1803.131,729.35,1732.447,716.946,1666.646,719.892C1606.842,722.569,1550.925,748.204,1518.776,798.703C1483.928,853.441,1469.224,923.13,1501.373,979.495C1533.756,1036.271,1601.292,1056.919,1666.646,1057.959",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask2285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient2286"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(76, 175, 80, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(27, 94, 32, 1)",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            @keyframes float1 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-10px, 0)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float1 {\r\n                animation: float1 5s infinite;\r\n            }\r\n\r\n            @keyframes float2 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-5px, -5px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float2 {\r\n                animation: float2 4s infinite;\r\n            }\r\n\r\n            @keyframes float3 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(0, -10px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float3 {\r\n                animation: float3 6s infinite;\r\n            }\r\n        "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGreen);
export default __webpack_public_path__ + "static/media/bgGreen.27f1c22702df3e1f8bcd60cc6a320601.svg";
export { ForwardRef as ReactComponent };